export default __webpack_public_path__ + "static/media/disney-springs.89c1324b.jpg";